import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  NavItem,
  NavLink,
  UncontrolledTooltip,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { showModal } from '../actions';

const WatchTourButton = ({ client, openModal }) => {
  const intl = useIntl();

  if (!client.welcome_tour_url) {
    return null;
  }

  const videoUrl = 'https://player.vimeo.com/video/834207096?h=5a4bce0dde&badge=0&byline=0&title=0';

  return (
    <>
      <NavItem className="watch-tour">
        <NavLink
          tag={Link}
          to={videoUrl}
          onClick={(e) => {
            e.preventDefault();
            openModal(videoUrl, intl.formatMessage({ defaultMessage: 'Stockpress demo' }));
          }}
          id="watch-tour-icon"
          aria-label={intl.formatMessage({ defaultMessage: 'Watch platform demo' })}
        >
          <i className="fal fa-circle-play" />
        </NavLink>
      </NavItem>
      <UncontrolledTooltip placement="bottom" target="watch-tour-icon" fade={false}>
        {intl.formatMessage({ defaultMessage: 'Watch platform demo' })}
      </UncontrolledTooltip>
    </>
  );
};

const mapStateToProps = state => ({
  client: state.Auth.profile?.client,
});

const mapDispatchToProps = dispatch => ({
  openModal: (url, title) => {
    dispatch(showModal('VideoPlayerModal', {
      className: 'modal-video-player',
      url,
      title,
      backdrop: true,
    }));
  },
});

WatchTourButton.propTypes = {
  openModal: PropTypes.func.isRequired,
  client: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(WatchTourButton);
